"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get convertBoundingBoxToPolygon () {
        return convertBoundingBoxToPolygon;
    },
    get outsideOfBoundary () {
        return outsideOfBoundary;
    }
});
const _turf = require("@turf/turf");
const _coordinates = require("common/utils/coordinates");
const convertBoundingBoxToPolygon = (boundingBox)=>{
    const [west, south] = boundingBox[0];
    const [east, north] = boundingBox[1];
    const polygonCoordinates = [
        [
            [
                west,
                south
            ],
            [
                east,
                south
            ],
            [
                east,
                north
            ],
            [
                west,
                north
            ],
            [
                west,
                south
            ]
        ]
    ];
    return (0, _turf.polygon)(polygonCoordinates);
};
const outsideOfBoundary = ({ point, boundary })=>{
    if (!point) return false;
    const validCoordinates = (0, _coordinates.confirmValidCoordinates)(point);
    if (!validCoordinates) return false;
    let areaPolygon;
    if (Array.isArray(boundary)) {
        if (!boundary.length) return false;
        areaPolygon = convertBoundingBoxToPolygon(boundary);
    } else {
        areaPolygon = boundary;
    }
    const inside = (0, _turf.booleanPointInPolygon)([
        validCoordinates.longitude,
        validCoordinates.latitude
    ], areaPolygon);
    return !inside;
};

//# sourceMappingURL=data:application/json;base64,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